"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get convertBoundingBoxToPolygon () {
        return convertBoundingBoxToPolygon;
    },
    get outsideOfBoundary () {
        return outsideOfBoundary;
    }
});
const _turf = require("@turf/turf");
const _coordinates = require("common/utils/coordinates");
const convertBoundingBoxToPolygon = (boundingBox)=>{
    const [west, south] = boundingBox[0];
    const [east, north] = boundingBox[1];
    const polygonCoordinates = [
        [
            [
                west,
                south
            ],
            [
                east,
                south
            ],
            [
                east,
                north
            ],
            [
                west,
                north
            ],
            [
                west,
                south
            ]
        ]
    ];
    return (0, _turf.polygon)(polygonCoordinates);
};
const outsideOfBoundary = ({ point, boundary })=>{
    if (!point) return false;
    const validCoordinates = (0, _coordinates.confirmValidCoordinates)(point);
    if (!validCoordinates) return false;
    let areaPolygon;
    if (Array.isArray(boundary)) {
        if (!boundary.length) return false;
        areaPolygon = convertBoundingBoxToPolygon(boundary);
    } else {
        areaPolygon = boundary;
    }
    const inside = (0, _turf.booleanPointInPolygon)([
        validCoordinates.longitude,
        validCoordinates.latitude
    ], areaPolygon);
    return !inside;
};

//# sourceMappingURL=data:application/json;base64,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